export default __webpack_public_path__ + "static/media/expand.6aa32000.svg";